'use client'

import { IconSearch } from '@macarongfactory/web-icons'
import { Divider, Text } from '@macarongfactory/web-ui'
import Link from 'next/link'

import { MycleLogoDefault } from '@/shared/assets/icons'

import {
  CAR_SEARCH_PATH,
  HOME_COPY,
  MYCLE_HOME_PATH,
  useHomeTracking,
} from '../_features/modoocar-home'

const LOGO_WIDTH_PX = '100'
const LOGO_HEIGHT_PX = '20'
const SEARCH_ICON_SIZE_PX = 24

const HomeTopBar = () => {
  const { logoClick } = useHomeTracking()

  return (
    <header className='sticky top-0 z-20 bg-background-surface-default'>
      <div className='flex items-center justify-center px-dimension-x5 py-dimension-x3'>
        <div className='flex w-full max-w-[640px] items-center justify-between'>
          <div className='flex items-center gap-dimension-x3'>
            <Link
              href={MYCLE_HOME_PATH}
              aria-label='마이클 홈'
              className='shrink-0 text-foreground-brand-strong'
              onClick={logoClick}
            >
              <MycleLogoDefault
                fill='currentColor'
                width={LOGO_WIDTH_PX}
                height={LOGO_HEIGHT_PX}
              />
            </Link>
            <Divider.Vertical height='x4' />
            <Text
              variant='title-2-semibold'
              color='text-foreground-neutral-strong'
            >
              {HOME_COPY.headerLabel}
            </Text>
          </div>
          <Link
            href={CAR_SEARCH_PATH}
            aria-label='차종 검색'
            className='shrink-0 text-foreground-neutral-strong'
          >
            <IconSearch
              width={SEARCH_ICON_SIZE_PX}
              height={SEARCH_ICON_SIZE_PX}
            />
          </Link>
        </div>
      </div>
    </header>
  )
}

export default HomeTopBar
